import _styled from "styled-components";
import React from "react";
import QRCode from "qrcode.react";
import { ModalScreen } from "../ModalScreen/ModalScreen";

var Content = _styled.div.withConfig({
  displayName: "QRCodeModal__Content",
  componentId: "z7lg4u-0"
})(["margin-top:120px;flex:1 1 auto;"]);

var TextInfo = _styled.div.withConfig({
  displayName: "QRCodeModal__TextInfo",
  componentId: "z7lg4u-1"
})([""]);

var Title = _styled.div.withConfig({
  displayName: "QRCodeModal__Title",
  componentId: "z7lg4u-2"
})(["text-align:center;font-size:28px;"]);

var TextDescription = _styled.div.withConfig({
  displayName: "QRCodeModal__TextDescription",
  componentId: "z7lg4u-3"
})(["text-align:center;margin-top:15px;font-size:20px;"]);

var QRContainer = _styled.div.withConfig({
  displayName: "QRCodeModal__QRContainer",
  componentId: "z7lg4u-4"
})(["display:flex;justify-content:center;margin-top:30px;"]);

export function QRCodeModal(_ref) {
  var onClose = _ref.onClose,
      value = _ref.value;
  var isOpen = !!value;
  return /*#__PURE__*/React.createElement(ModalScreen, {
    isOpen: isOpen,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(TextInfo, null, /*#__PURE__*/React.createElement(Title, null, "QR-\u043A\u043E\u0434 \u0441\u0441\u044B\u043B\u043A\u0438"), /*#__PURE__*/React.createElement(TextDescription, null, value)), /*#__PURE__*/React.createElement(QRContainer, null, isOpen && /*#__PURE__*/React.createElement(QRCode, {
    value: value,
    size: 256,
    level: "M"
  }))));
}